import { gql } from "lib/apolloClient";
import {
  platformCalendarEventFragments,
  videoMeetingFragments,
} from "./MyCalendarFragments";

export const createPlatformCalendarEventMutation = gql`
  mutation createPlatformCalendarEvent(
    $label: String!
    $startAt: String
    $description: String
    $durationInMin: Int
    $recurrenceSetting: RecurrenceSettingInput
    $metadata: CalendarEventItemMetadataInput
    $meeting: MeetingInput
    $courseIds: [ID!]
    $userIds: [ID!]
    $location: String
    $startDateTime: String
    $endDateTime: String
    $categoryId: ID
    $entityIds: [ID!]
    $isFullDayEvent: Boolean
    $eventType: CALENDAR_EVENT_ITEM_TYPE_ENUM
    $entityType: CALENDAR_EVENT_ITEM_ENTITY_TYPE_ENUM
    $attachments: [AttachmentInput!]
    $sharedWith: [CALENDAR_EVENT_ITEM_SHARED_WITH_ENUM!]
    $eventReminders: [EventReminderInput!]
    $shouldNotifyParticipants: Boolean
    $shouldUseNewMeetingInfra: Boolean
  ) {
    platform {
      createPlatformCalendarEvent(
        input: {
          label: $label
          startAt: $startAt
          description: $description
          durationInMin: $durationInMin
          recurrenceSetting: $recurrenceSetting
          meeting: $meeting
          courseIds: $courseIds
          userIds: $userIds
          location: $location
          startDateTime: $startDateTime
          endDateTime: $endDateTime
          categoryId: $categoryId
          entityIds: $entityIds
          isFullDayEvent: $isFullDayEvent
          eventType: $eventType
          entityType: $entityType
          attachments: $attachments
          sharedWith: $sharedWith
          eventReminders: $eventReminders
          shouldNotifyParticipants: $shouldNotifyParticipants
          metadata: $metadata
          shouldUseNewMeetingInfra: $shouldUseNewMeetingInfra
        }
      ) {
        response {
          ...platformCalendarEventItem
        }
        warning
      }
    }
  }
  ${platformCalendarEventFragments.platformCalendarEventDetails}
`;

export const createVideoMeetingMutation = gql`
  mutation createVideoMeeting(
    $label: String!
    $description: String
    $durationInMin: Int
    $recurrenceSetting: RecurrenceSettingInput
    $metadata: CalendarEventItemMetadataInput
    $meeting: MeetingInput
    $startDateTime: String
    $endDateTime: String
    $entityIds: [ID!]
    $eventType: CALENDAR_EVENT_ITEM_TYPE_ENUM
    $entityType: CALENDAR_EVENT_ITEM_ENTITY_TYPE_ENUM
    $attachments: [AttachmentInput!]
    $sharedWith: [CALENDAR_EVENT_ITEM_SHARED_WITH_ENUM!]
    $eventReminders: [EventReminderInput!]
    $shouldNotifyParticipants: Boolean
    $shouldUseNewMeetingInfra: Boolean
  ) {
    platform {
      createPlatformCalendarEvent(
        input: {
          label: $label
          description: $description
          durationInMin: $durationInMin
          recurrenceSetting: $recurrenceSetting
          meeting: $meeting
          startDateTime: $startDateTime
          endDateTime: $endDateTime
          entityIds: $entityIds
          eventType: $eventType
          entityType: $entityType
          attachments: $attachments
          sharedWith: $sharedWith
          eventReminders: $eventReminders
          shouldNotifyParticipants: $shouldNotifyParticipants
          metadata: $metadata
          shouldUseNewMeetingInfra: $shouldUseNewMeetingInfra
        }
      ) {
        response {
          ...videoMeetingItem
        }
        warning
      }
    }
  }
  ${videoMeetingFragments.videoMeetingDetails}
`;

export const editVideoMeetingMutation = gql`
  mutation editVideoMeetingMutation(
    $id: ID!
    $label: String!
    $description: String
    $durationInMin: Int
    $recurrenceSetting: RecurrenceSettingInput
    $metadata: CalendarEventItemMetadataInput
    $meeting: MeetingInput
    $startDateTime: String
    $endDateTime: String
    $eventType: CALENDAR_EVENT_ITEM_TYPE_ENUM
    $entityType: CALENDAR_EVENT_ITEM_ENTITY_TYPE_ENUM
    $sharedWith: [CALENDAR_EVENT_ITEM_SHARED_WITH_ENUM!]
    $eventReminders: [EventReminderInput!]
    $shouldNotifyParticipants: Boolean
    $actionFor: CALENDAR_EVENT_ACTION_FOR
    $addedEntityIds: [ID!]
    $addedAttachments: [AttachmentInput!]
    $removedAttachments: [ID!]
    $notificationMessage: String
    $shouldUseNewMeetingInfra: Boolean
  ) {
    platform {
      editPlatformCalendarEvent(
        input: {
          id: $id
          label: $label
          description: $description
          durationInMin: $durationInMin
          recurrenceSetting: $recurrenceSetting
          meeting: $meeting
          actionFor: $actionFor
          startDateTime: $startDateTime
          endDateTime: $endDateTime
          addedEntityIds: $addedEntityIds
          entityType: $entityType
          eventType: $eventType
          addedAttachments: $addedAttachments
          removedAttachments: $removedAttachments
          sharedWith: $sharedWith
          eventReminders: $eventReminders
          notificationMessage: $notificationMessage
          shouldNotifyParticipants: $shouldNotifyParticipants
          metadata: $metadata
          shouldUseNewMeetingInfra: $shouldUseNewMeetingInfra
        }
      ) {
        response {
          ...videoMeetingItem
        }
        warning
      }
    }
  }
  ${videoMeetingFragments.videoMeetingDetails}
`;

export const deletePlatformCalendarEventMutation = gql`
  mutation deletePlatformCalendarEvent(
    $id: ID!
    $actionFor: CALENDAR_EVENT_ACTION_FOR
    $eventType: CALENDAR_EVENT_ITEM_TYPE_ENUM
    $isFullDayEvent: Boolean
    $notificationMessage: String
    $shouldNotifyParticipants: Boolean
    $shouldUseNewMeetingInfra: Boolean
  ) {
    platform {
      deletePlatformCalendarEvent(
        input: {
          id: $id
          actionFor: $actionFor
          eventType: $eventType
          isFullDayEvent: $isFullDayEvent
          notificationMessage: $notificationMessage
          shouldNotifyParticipants: $shouldNotifyParticipants
          shouldUseNewMeetingInfra: $shouldUseNewMeetingInfra
        }
      ) {
        response
      }
    }
  }
`;

export const editPlatformCalendarEventMutation = gql`
  mutation editPlatformCalendarEvent(
    $id: ID!
    $label: String!
    $startAt: String
    $description: String
    $durationInMin: Int
    $recurrenceSetting: RecurrenceSettingInput
    $metadata: CalendarEventItemMetadataInput
    $meeting: MeetingInput
    $removedCourseIds: [ID!]
    $addedCourseIds: [ID!]
    $removedUserIds: [ID!]
    $addedUserIds: [ID!]
    $actionFor: CALENDAR_EVENT_ACTION_FOR
    $startDateTime: String
    $endDateTime: String
    $location: String
    $addedEntityIds: [ID!]
    $removedEntityIds: [ID!]
    $entityType: CALENDAR_EVENT_ITEM_ENTITY_TYPE_ENUM
    $eventType: CALENDAR_EVENT_ITEM_TYPE_ENUM
    $categoryId: ID
    $isFullDayEvent: Boolean
    $addedAttachments: [AttachmentInput!]
    $removedAttachments: [ID!]
    $sharedWith: [CALENDAR_EVENT_ITEM_SHARED_WITH_ENUM!]
    $eventReminders: [EventReminderInput!]
    $notificationMessage: String
    $shouldNotifyParticipants: Boolean
    $shouldUseNewMeetingInfra: Boolean
  ) {
    platform {
      editPlatformCalendarEvent(
        input: {
          id: $id
          label: $label
          startAt: $startAt
          description: $description
          durationInMin: $durationInMin
          recurrenceSetting: $recurrenceSetting
          meeting: $meeting
          removedCourseIds: $removedCourseIds
          addedCourseIds: $addedCourseIds
          removedUserIds: $removedUserIds
          addedUserIds: $addedUserIds
          actionFor: $actionFor
          startDateTime: $startDateTime
          endDateTime: $endDateTime
          location: $location
          addedEntityIds: $addedEntityIds
          removedEntityIds: $removedEntityIds
          entityType: $entityType
          eventType: $eventType
          categoryId: $categoryId
          isFullDayEvent: $isFullDayEvent
          addedAttachments: $addedAttachments
          removedAttachments: $removedAttachments
          sharedWith: $sharedWith
          eventReminders: $eventReminders
          notificationMessage: $notificationMessage
          shouldNotifyParticipants: $shouldNotifyParticipants
          metadata: $metadata
          shouldUseNewMeetingInfra: $shouldUseNewMeetingInfra
        }
      ) {
        response {
          ...platformCalendarEventItem
        }
        warning
      }
    }
  }
  ${platformCalendarEventFragments.platformCalendarEventDetails}
`;

export const updatePlatformCalendarEventBasicDetailsMutation = gql`
  mutation updatePlatformCalendarEventBasicDetails(
    $id: ID!
    $startAt: String
    $durationInMin: Int
    $itemType: CALENDAR_EVENT_ITEM_TYPE_ENUM!
    $startDateTime: String
    $endDateTime: String
    $isFullDayEvent: Boolean
    $eventType: CALENDAR_EVENT_ITEM_TYPE_ENUM
    $notificationMessage: String
    $shouldNotifyParticipants: Boolean
    $shouldUseNewMeetingInfra: Boolean
  ) {
    platform {
      updatePlatformCalendarEventBasicDetails(
        input: {
          id: $id
          startAt: $startAt
          durationInMin: $durationInMin
          itemType: $itemType
          startDateTime: $startDateTime
          endDateTime: $endDateTime
          isFullDayEvent: $isFullDayEvent
          eventType: $eventType
          notificationMessage: $notificationMessage
          shouldNotifyParticipants: $shouldNotifyParticipants
          shouldUseNewMeetingInfra: $shouldUseNewMeetingInfra
        }
      ) {
        response {
          ...platformCalendarEventItem
        }
        warning
      }
    }
  }
  ${platformCalendarEventFragments.platformCalendarEventDetails}
`;

export const createCalendarSyncAccessToken = gql`
  mutation createUserAccessToken($input: GenerateUserAccessTokenInput!) {
    platform {
      generateUserAccessToken(input: $input) {
        warning
        response {
          id
          serviceType
          accessToken
        }
      }
    }
  }
`;

export const updateAssignmentScheduleAndDueTime = gql`
  mutation updateAssignmentV2(
    $id: ID!
    $courseId: ID!
    $publishedAt: String
    $deadline: String
    $closeSubmissionDate: String
  ) {
    platform {
      updateAssignmentV2(
        input: {
          id: $id
          courses: {
            updatedCourses: {
              courseId: $courseId
              publishedAt: $publishedAt
              deadline: $deadline
              closeSubmissionDate: $closeSubmissionDate
            }
          }
        }
      ) {
        warning
        response {
          id
          deadline
          publishedAt
          closeSubmissionDate
        }
      }
    }
  }
`;

export const createThirdPartyMeetingLinkMutation = gql`
  mutation createThirdPartyMeetingLink(
    $serviceType: THIRD_PARTY_SERVICE_TYPE!
  ) {
    platform {
      createThirdPartyMeetingLink(input: { serviceType: $serviceType }) {
        response {
          id
          meetingUrl
          meetingData
          type
          createdAt
          createdBy {
            id
          }
        }
        warning
      }
    }
  }
`;
